
import React, { Component } from 'react';
import {Row , Col, Button, Table, Pagination, FormControl } from 'react-bootstrap';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _ from 'lodash';
import moment from "moment";
function searchingFor(filterRows){
	return function(x){
      let key = _.keys(filterRows)
      let newObj =[]
      if(!_.isEmpty(key)){        
       _.map(key, (gg) =>{  
        if(!_.isNull(x[gg])){
          if(typeof x[gg] === "string"){
            newObj.push(x[gg].toLowerCase().includes(filterRows[gg].toLowerCase()))
          } else {
            newObj.push(x[gg].toString().includes(filterRows[gg].toString()))
          }
        }
      })
    }
    if(!_.isEmpty(newObj)){
      return !_.includes(newObj, false)
    } else {
       return true
    }
  }
}
export default class Assign extends Component {
  constructor(props){
    super(props)
    this.state = this.getInitialState()
    this.bulkclientName = []
  }
  getInitialState = () =>{
    return {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      selectedReAssignAuditor:[],
      selectedRows:[],
      newRow:[],
      activePage:1,
      filterRows:{},
      showFilter:false,
      search:false,
      selectedAuditor:[],
      searchData:[],
      startDate:'',
      endDate:''
    }
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
      }    
  }
  componentWillReceiveProps(nextProps){    
    const{searchData} = this.state;
    if(nextProps.reassiged === true && !_.isEqual(this.props.reassiged, nextProps.reassiged)){
      if(!_.isEmpty(this.state.searchData)){
        // let index = _.findLastIndex(this.state.selectedRows)
        // for( let i=0 ; i <=index; i++){
        //   this.setState({['isSelected'+i]:false})
        // }
        _.filter(this.state.selectedRows, (obj) =>{ 
          this.setState({['isSelected'+obj.id]:false})
          _.remove(searchData, obj) })
          
          if(!_.isNull(this.state.filterRows)){
            let keys = _.keys(this.state.filterRows)
            _.map(keys, (obj) =>{
              this.setState({[obj]:""})
            })
          }
        this.setState({searchData, selectedRows:[], selectedReAssignAuditor:[], filterRows:{}, showFilter:false})        
      } else {
        this.props.action.ResetAll()
        this.setState({searchData:[], selectedAuditor:[], search:false, startDate:null, endDate:null, selectedregionName:[]})
      } 
    } else {
      if(this.state.search === true && nextProps.reassiged === false && !_.isEmpty(nextProps.searchData)){
        this.setState({searchData:_.cloneDeep(nextProps.searchData)})
      }
    }
  }
  regionNames = (prop) => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
    let regionNames = _.filter(inventory); 
    return regionNames;
    }
    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    const{inventory} = this.props;
    let centerName=[];
    if(!_.isEmpty(inventory)){
      centerName =selectedregionName.userCenters
      return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    const{inventory} = this.props;
    let clientName=[];
    if(!_.isEmpty(inventory)){
    _.map(selectedcenterName, (obj)=>{
        let x = _.filter(obj.userClients);
        clientName.push(...x );
        this.bulkclientName=clientName
    }) 
    return _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    const{inventory} = this.props;
    let processName=[];
    if(!_.isEmpty(inventory)){
    _.map(selectedclientName, (obj)=>{
        let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
        _.map(abc, (z) => {
          processName.push(...z.userProcesses)
          processName = _.uniqBy(processName, 'inventoryProcessId');
        }) 
    }) 
    return processName;
    }
  }
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e} );
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], selectedAuditor:[], startDate:'', endDate:''})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[], selectedAuditor:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], selectedAuditor:[]})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});
    const {selectedregionName, selectedcenterName, selectedclientName} = this.state;
    let region = [selectedregionName.inventoryRegionId]
    let centers = _.map(selectedcenterName, (cx) => { 
      return(cx.inventoryCenterId)
    })
    let clients = _.map(selectedclientName, (cx) => { 
      return(cx.inventoryClientId)
    })   
    let process = _.map(e, (cx) => { 
      return(cx.inventoryProcessId)
    })     
    let obj = {
      'regions': region,
      'centers': centers,
      'clients': clients,
      'processes': process
    }    
    this.props.action.SearchQANames(obj)
  }
  handleSelectAuditor = (e) => {
    this.setState({selectedAuditor: e});
    if(!_.isEqual(this.state.selectedAuditor, e)){
      this.setState({search:false})
    }
  }
  handleSelectReAssignAuditor = (e, index, obj) => {
    const{newRow} = this.state
    this.setState({['selectedReAssignAuditor'+index]: e});
    if(!_.isEmpty(newRow[index])){
      let row = newRow[index]
      let filtered = _.find(row, {'label':'mulipleAuditors'});
      if(!_.isEmpty(filtered)){
        filtered.value  = e
      } else {
        let x = {'label':'mulipleAuditors', 'value':e}
        row.push(x)
      }
      this.setState({newRow})
    } else {
      let row = obj[index]
      let x = {'label':'mulipleAuditors', 'value':e}
      row.push(x)
      newRow.push(row)
      this.setState({newRow})
    }
  }

  handleSelectQA = (e) => {
    this.setState({selectedReAssignAuditor: e});
  }
  handleChangeStart = (date) => {
  // date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
    this.setState({startDate: date});
  }
  handleChangeEnd = (e) => {
    //e.setMinutes( e.getMinutes() + e.getTimezoneOffset() );
    this.setState({endDate: e});
  }
  auditorNames = () => {
   let obj = this.props.QANameList  
   return obj;
  }
  SelectedAuditorNames = () => {
    let obj = this.props.QANameList  
    let data = _.filter(obj, (val) => { 
      return (!_.isEqual(val,this.state.selectedAuditor))         
    })
    return data;
   }
  SearchTemplate = () => {
  const{selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, selectedAuditor, startDate, endDate} = this.state;
  this.setState({search:true}) 
  let obj = {
    "regionId":  selectedregionName.inventoryRegionId,
    "center": _.map(selectedcenterName, (x) =>{return(x.inventoryCenterId)}),
    "client": _.map(selectedclientName, (x) =>{return(x.inventoryClientId)}),
    "process":_.map(selectedprocessName, (x) =>{return(x.inventoryProcessId)}),
    "empId": selectedAuditor.qaId,
    'startDate':moment(startDate).format('YYYY-MM-DD'),
    'endDate':moment(endDate).format('YYYY-MM-DD'),
    }
    this.props.action.TokenValidation()    
    this.props.action.searchReAssignRecords(obj)
    
    
  }
  validateForm() {    
      if(this.state.selectedprocessName && !_.isEmpty(this.state.selectedprocessName) 
         && (typeof this.state.startDate !== 'undefined')  && (typeof this.state.endDate !== 'undefined'))
      return true;
  }

  selectRow = (obj, index) => {
    const{selectedRows} = this.state
    if(!this.state['isSelected'+index]){
      selectedRows.push(obj)
    } else {
      _.pull(selectedRows, obj)
    }
    this.setState({selectedRows, ['isSelected'+index]:!this.state['isSelected'+index]})
  }
 
renderInboxValues = (data, startOffset, startCount, Per_Page, filterRows) => {  
    if(!_.isEmpty(data)){
    return _.map(data.filter(searchingFor(filterRows)), (obj, index) =>{  
      if(index >= startOffset & startCount < Per_Page){
        startCount++;
      return(<tr className={this.state['isSelected'+obj.id] ? 'isselected' : ''}onClick={()=>this.selectRow(obj, obj.id)}>
        <td>{obj.id}</td><td>{obj.agentName}</td> <td>{obj.regionName}</td> <td>{obj.centerName}</td>
        <td>{obj.clientName}</td><td>{obj.processName}</td><td>{obj.mobileNo}</td><td>{obj.callDate}</td>    
      </tr>)
      }
     });
  } else {
    return (<tr><td colSpan="8">No Record Record</td></tr>)
  }
}
handleSave = () => {
  const{selectedRows, selectedReAssignAuditor} = this.state;
  let obj = {
    "recordId":  _.map(selectedRows, (x) =>{return(x.id)}),
    "auditorId": selectedReAssignAuditor.qaId
  }
  this.props.action.TokenValidation()    
  this.props.action.submitReAssignRecords(obj)  
}
validateFormAssign() {    
  if(!_.isEmpty(this.state.selectedRows) && !_.isEmpty(this.state.selectedReAssignAuditor))
  return true;
}
handleSelectPagination = (eventKey) => {
  this.setState({
    activePage: eventKey,
  });
}
handleSelectPaginationPrev = () => {
  const {activePage} = this.state;
  this.setState({
    activePage: activePage-1,
  });
}
handleSelectPaginationNext = () => {
  const {activePage} = this.state;
  this.setState({
    activePage: activePage+1,
  });
}
resetTemplate = () => {
  this.setState(this.getInitialState())
}
handleFilter = () =>{
  this.setState((prevState) =>{
    return {showFilter: !prevState.showFilter};
  })
  if(!_.isNull(this.state.filterRows)){
    let keys = _.keys(this.state.filterRows)
    _.map(keys, (obj) =>{
      this.setState({[obj]:""})
    })
    this.setState({filterRows:{}})
  }
}
handleChange = (e) => {
  const {filterRows} = this.state
  let filterCol = filterRows
  if(_.has(filterCol, e.target.id)){
    filterCol[e.target.id]  = e.target.value
  } else {
    filterCol = Object.assign(filterCol, {[e.target.id]:e.target.value})
  }
  this.setState({[e.target.id]:e.target.value, filterRows:filterCol})	
}
render(){
  const{search, activePage, showFilter, filterRows} = this.state;
  const Per_Page=50;  
  let totalPages = 1
  if(!_.isEmpty(this.props.searchData)){
    totalPages = Math.ceil(this.props.searchData.length/Per_Page)
  }
  let items = []; 
  let filterfield =[];
    filterfield.push(
      <tr className='filterRow' style={{'backgroundColor':'white'}}>
      <td></td>
      <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"agentName"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.agentName}
      /></td>
      <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"regionName"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.regionName}
      /></td>
            <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"centerName"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.centerName}
      /></td>
            <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"clientName"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.clientName}
      /></td>
            <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"processName"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.processName}
      /></td>
      <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"mobileNo"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.mobileNo}
      /></td>
       <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={"callDate"}
      onChange={(e) => this.handleChange(e)}
      value={this.state.callDate}
      /></td>
      </tr>
    )
  const startOffset = (this.state.activePage-1) * Per_Page;
  let startCount = 0;
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
        {number}
      </Pagination.Item>				
    );
  } 
   return(
      <div className='margingap'>
      <Row>
        <Col>
          <label>Region Name</label>
        </Col>
        <Col>
        <Picky keepOpen={false}
          value={this.state.selectedregionName}
          options={this.regionNames()}
          onChange={this.handleSelect}
          open={false}
          valueKey="inventoryRegionName"
          labelKey="inventoryRegionName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='Select Region'
          dropdownHeight={600}
        />
        </Col>
      </Row> 
      <Row>
        <Col>
          <label>Center Name</label>
        </Col>
        <Col>
        <Picky keepOpen={false}
          value={this.state.selectedcenterName}
          options={this.centerNames()}
          onChange={this.handleSelectCenter}
          open={false}
          valueKey="inventoryCenterName"
          labelKey="inventoryCenterName"
          multiple={true}
          includeSelectAll={true}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='Select Center'
          dropdownHeight={600}
        />
        </Col>             
      </Row>
      <Row>
      <Col>
      <label>Client Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedclientName}
        options={this.clientNames()}
        onChange={this.handleSelectClient}
        open={false}
        valueKey="inventoryClientName"
        labelKey="inventoryClientName"
        multiple={true}
        includeSelectAll={true}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Client'
        dropdownHeight={600}
      />
      </Col>
      </Row> 
      <Row>
      <Col>
      <label>Process Name *</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedprocessName}
        options={this.processNames()}
        onChange={this.handleSelectProcess}
        open={false}
        valueKey="inventoryProcessName"
        labelKey="inventoryProcessName"
        multiple={true}
        includeSelectAll={true}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Process Name'
        dropdownHeight={600}
      />
       </Col>
       </Row> 
      <Row>
      <Col>
      <label>QA Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedAuditor}
        options={this.auditorNames()}
        onChange={this.handleSelectAuditor}
        open={false}
        valueKey="qaName"
        labelKey="qaName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select QA'
        dropdownHeight={600}
      />
       </Col>
       </Row>
       <Row>
      <Col>
      <label>Date Range *</label>
      </Col>
      <Col className='myContainter'>
           <DatePicker
            selected={this.state.startDate}
            className='myDatePicker'
            selectsStart
            showMonthDropdown
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeStart}
            />
            <DatePicker
            selected={this.state.endDate}
            selectsEnd
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeEnd}
            minDate={this.state.startDate}
            maxDate={new Date()}
            />     
       </Col>
       </Row>
        <br/>
        <Row><Col  md={4}></Col>
        <Col className='centered' md={2}><Button className='buttonwidth' onClick={this.SearchTemplate}  disabled={!this.validateForm()}>Search</Button></Col>
        <Col className='centered' md={2}><Button className='buttonwidth' onClick={this.resetTemplate} >Reset</Button></Col>
        {((search)) ?  <Col className='centered' md={2}>
          <Picky keepOpen={false}
          value={this.state.selectedReAssignAuditor}
          options={this.SelectedAuditorNames()}
          onChange={this.handleSelectQA}
          open={false}
          valueKey="qaName"
          labelKey="qaName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='Select QA'
          dropdownHeight={600}
        /> </Col> : null}
        {((search)) ?  <Col className='centered' md={2}>
         <Button className='buttonwidth alignRight' onClick={this.handleSave} disabled={!this.validateFormAssign()} >Assign</Button>
         </Col>: null}
        </Row>
        {((search)) ?        
      <div>
      <Table responsive className='noalternate'>
        <thead>
          <tr>
            <th><i class="fas fa-filter filterReport" onClick={this.handleFilter}/>TRANSACTION NO</th>      
            <th>AGENT NAME</th>      
            <th>REGION</th>
            <th>CENTER</th>
            <th>CLIENT</th>
            <th>PROCESS</th>
            <th>MOBILE NO</th>
            <th>DATE</th></tr>
            {showFilter ? filterfield : null} 
        </thead>
        <tbody>
          { this.renderInboxValues(this.state.searchData, startOffset, startCount, Per_Page, filterRows) }          
        </tbody>
      </Table>
      {/* <Row>
      <Col></Col>              
      <Col>
        <Picky keepOpen={false}
          value={this.state.selectedReAssignAuditor}
          options={this.auditorNames()}
          onChange={this.handleSelectQA}
          open={false}
          valueKey="qaName"
          labelKey="qaName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='Select QA'
          dropdownHeight={600}
        /></Col>
      <Col>
        <Button className='buttonwidth alignRight' onClick={this.handleSave} disabled={!this.validateFormAssign()} >Assign</Button></Col>
      </Row> */}
      <Pagination>
          <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
          <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
            {items[activePage-1]}
            {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
            {items[activePage+1]}
          <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
          <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
      </Pagination> 
      </div>      
      : null}
    
    
  </div>)
      
  }
}    


